var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.973,
    height: 23.991
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.487 21.993V6.828l-5.073 5.073a2 2 0 01-2.828 0 2 2 0 010-2.832L9.071.586a2 2 0 012.832 0l8.482 8.483a2 2 0 010 2.832 2 2 0 01-2.829 0l-5.069-5.068v15.162a2 2 0 01-2 2 2 2 0 01-2-2.002z",
    fill: "#ffac3c"
  })));
}
export default SvgUploadIcon;